import React, { useEffect, useMemo } from 'react';
import { Button } from '@this/shared/ui/inputs/button';
import { Textarea } from '@this/shared/ui/inputs/textarea';
import { Select } from '@this/shared/ui/inputs/select';
import type CancelChargeElement from '@this/domain/cancel_charge_element2';
import { observer } from 'mobx-react';
import DatetimePicker from '../../../../../shared/datetime_picker/datetime_picker';

interface Props {
  element: CancelChargeElement;
  traceId: number | undefined;
  traceItems: Record<number, string>;
  classNameForModifiedField: (...path: (string | number)[]) => string;
}

const CancelElementForm = ({ element, traceId, traceItems, classNameForModifiedField }: Props) => {
  const mappingOptions = useMemo(
    () =>
      Object.entries(traceItems)
        .filter(([id]) => id !== traceId?.toString())
        .map(([id, label]) => ({ traceId: parseInt(id, 10), label })),
    [traceItems]
  );

  useEffect(() => {
    if (element.mappings.length < 1) element.addMapping();
  }, [element]);

  return (
    <>
      <div className="virtual-counte-price-change-form__input-wrapper">
        <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('content')}`}>
          内容
          <span className="red">（必須）</span>
        </label>
        <Textarea
          value={element.content}
          onChange={e => {
            element.content = e.target.value;
          }}
        />
      </div>
      <div className="virtual-counte-price-change-form__input-wrapper-item">
        <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('canceledAt')}`}>
          キャンセル日
        </label>
        <DatetimePicker
          value={element.canceledAt}
          onChange={time => {
            element.canceledAt = time;
          }}
          showTime={false}
          disabledDays={0}
          showPast
        />
      </div>
      <div className="virtual-counte-price-change-form__input-wrapper-item">
        <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('startAt')}`}>
          元の商品の利用開始日
        </label>
        <DatetimePicker
          value={element.startAt}
          onChange={time => {
            element.startAt = time;
          }}
          showTime={false}
          disabledDays={0}
          showPast
        />
      </div>
      <div className="virtual-counte-price-change-form__input-wrapper-item">
        <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('endAt')}`}>
          元の商品の利用終了日
        </label>
        <DatetimePicker
          value={element.endAt}
          onChange={time => {
            element.endAt = time;
          }}
          showTime={false}
          disabledDays={0}
          showPast
        />
      </div>
      <div className="virtual-counte-price-change-form__input-wrapper">
        <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('mappings')}`}>
          キャンセル商品
        </label>
      </div>
      {element.mappings.map((mapping, i) => (
        <div key={`mapping-${i}`} className="virtual-counte-price-change-form__input-wrapper-item">
          <Select
            value={mapping.originalTraceId?.toString() || ''}
            onChange={e => {
              mapping.originalTraceId = parseInt(e.target.value, 10) || undefined;
            }}
            style={{ width: 'calc(100% - 40px)' }}
          >
            <option key="">選択してください</option>
            {mappingOptions.map(({ traceId, label }) => (
              <option key={traceId} value={traceId.toString()}>
                trace_id-{traceId}: {label}
              </option>
            ))}
          </Select>
          {i > 0 && (
            <Button
              onClick={() => element.removeMapping(i)}
              size="small"
              style={{ padding: 0, marginLeft: 20, minWidth: 20, height: 20, borderRadius: 10 }}
            >
              ×
            </Button>
          )}
        </div>
      ))}
      {element.mappings.length < mappingOptions.length && (
        <div className="virtual-counte-price-change-form__input-wrapper-item">
          <Button onClick={() => element.addMapping()}>キャンセル商品を追加する</Button>
        </div>
      )}
    </>
  );
};

export default observer(CancelElementForm);
